"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _ProfileProvider = require("@jobmatchme/profile-components/es/provider/ProfileProvider");

var _ConfigProvider = _interopRequireWildcard(require("@jobmatchme/profile-components/es/provider/ConfigProvider"));

var _Tracking = require("@jobmatchme/tracking/es/provider/Tracking");

var _lazy = _interopRequireDefault(require("@jobmatchme/profile-components/es/components/Funnel/lazy"));

var _ThemeProvider = _interopRequireDefault(require("@jobmatchme/ui/es/provider/ThemeProvider"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ResettableFunnel = function ResettableFunnel(_ref) {
  var actionButton = _ref.actionButton,
      onComplete = _ref.onComplete,
      startScreen = _ref.startScreen,
      resettable = _ref.resettable,
      _ref$configKey = _ref.configKey,
      configKey = _ref$configKey === void 0 ? 'funnel' : _ref$configKey,
      applicationRoutes = _ref.applicationRoutes;

  var _useContext = (0, _react.useContext)(_ConfigProvider.ConfigurationContext),
      loadConfiguration = _useContext.loadConfiguration;

  var resetConfiguration = resettable ? function () {
    return loadConfiguration(undefined);
  } : undefined;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lazy.default, {
    configKey: configKey,
    onComplete: onComplete,
    startScreen: startScreen,
    actionButton: actionButton,
    onCancel: resetConfiguration,
    progressStepperVariant: "default",
    applicationRoutes: applicationRoutes
  });
};

var ConfiguredFunnel = function ConfiguredFunnel(_ref2) {
  var config = _ref2.config,
      startScreen = _ref2.startScreen,
      actionButton = _ref2.actionButton,
      loadableConfigs = _ref2.loadableConfigs,
      _ref2$resettable = _ref2.resettable,
      resettable = _ref2$resettable === void 0 ? false : _ref2$resettable,
      _ref2$configKey = _ref2.configKey,
      configKey = _ref2$configKey === void 0 ? 'funnel' : _ref2$configKey,
      applicationRoutes = _ref2.applicationRoutes,
      buttonLeftText = _ref2.buttonLeftText,
      preselection = _ref2.preselection,
      variant = _ref2.variant,
      onCancel = _ref2.onCancel,
      onComplete = _ref2.onComplete,
      onConfiguredConfirm = _ref2.onConfiguredConfirm;
  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var _useComponentTracking = (0, _Tracking.useComponentTracking)('ConfiguredFunnel'),
      pcDataLayerPush = _useComponentTracking.pcDataLayerPush;

  var trackFunnelStep = (0, _react.useCallback)(function (data) {
    if (data.type === 'funnelStep') {
      var segments = data.discriminator.split('-').concat(data.step.split('-'));
      var key = segments.map(function (s) {
        return s[0].toUpperCase() + s.slice(1).toLowerCase();
      }).join('');
      navigate({
        pathname: "./".concat(key, "/"),
        search: search
      }, {
        replace: true
      });
      pcDataLayerPush('funnel', data.profile, undefined, undefined, data.step);
    }
  }, [navigate, search, pcDataLayerPush]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
    variant: 'jmm',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfigProvider.default, {
      translateNs: "pc-funnel:ChooseConfig",
      config: config,
      loadableConfigs: loadableConfigs,
      preselection: preselection,
      onCancel: onCancel,
      buttonLeftText: buttonLeftText,
      onConfiguredConfirm: onConfiguredConfirm,
      actionButton: actionButton,
      applicationRoutes: applicationRoutes,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileProvider.ProfileProvider, {
        track: trackFunnelStep,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ResettableFunnel, {
          actionButton: actionButton,
          onComplete: onComplete,
          startScreen: startScreen,
          resettable: resettable,
          configKey: configKey,
          applicationRoutes: applicationRoutes
        })
      })
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(ConfiguredFunnel);

exports.default = _default;